import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios, { authHeaders } from "../../helpers/axios";
import { apiEndpoints } from "../../helpers/constants";
import { reqToForceUserLogout } from "./userSlice";

export const reqToGetDMReportList = createAsyncThunk(
  apiEndpoints.getDMReportList,
  async ({ data, onSuccess, onFailure, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.getDMReportList,
        data,
        authHeaders()
      );
      onSuccess?.(response.data);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);

export const reqToGetDMAllReportList = createAsyncThunk(
  `${apiEndpoints.getDMReportList}_all`,
  async ({ data, onSuccess, onFailure, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.getDMReportList,
        data,
        authHeaders()
      );
      onSuccess?.(response.data);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);

export const reqToGetAdminReportList = createAsyncThunk(
  apiEndpoints.getAdminReportList,
  async ({ data, onSuccess, onFailure, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.getAdminReportList,
        data,
        authHeaders()
      );
      onSuccess?.(response.data);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);

export const reqToGetAdminAllReportList = createAsyncThunk(
  `${apiEndpoints.getAdminReportList}_all`,
  async ({ data, onSuccess, onFailure, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.getAdminReportList,
        data,
        authHeaders()
      );
      onSuccess?.(response.data);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);

export const reqToGetTerritoryList = createAsyncThunk(
  apiEndpoints.getTerritoryList,
  async ({ data, onSuccess, onFailure, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.getTerritoryList,
        data,
        authHeaders()
      );
      onSuccess?.(response.data);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);

export const reqToGetDMRestaurantList = createAsyncThunk(
  apiEndpoints.getDMRestaurantList,
  async ({ data, onSuccess, onFailure, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.getDMRestaurantList,
        data,
        authHeaders()
      );
      onSuccess?.(response.data);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);

export const reqToGetAdminRestaurantList = createAsyncThunk(
  apiEndpoints.getAdminRestaurantList,
  async ({ data, onSuccess, onFailure, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.getAdminRestaurantList,
        data,
        authHeaders()
      );
      onSuccess?.(response.data);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);


export const reqToGetAdminUserReportList = createAsyncThunk(
  apiEndpoints.getAdminUserReport,
  async ({ data, onSuccess, onFailure, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        apiEndpoints.getAdminUserReport,
        {
          params : data,
          headers : authHeaders().headers
        }
      );
      onSuccess?.(response.data);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);

export const reqToGetAdminUsersList = createAsyncThunk(
  apiEndpoints.getAdminReportUsers,
  async ({ data, onSuccess, onFailure, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        apiEndpoints.getAdminReportUsers,
        {
          params : data,
          headers : authHeaders().headers
        }
      );
      onSuccess?.(response.data);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);


export const reqToGetAdminReportRestaurants = createAsyncThunk(
  apiEndpoints.getAdminReportRestaurants,
  async ({ data, onSuccess, onFailure, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${apiEndpoints.getAdminReportRestaurants}${data?.id}`,
        authHeaders()
      );
      onSuccess?.(response.data);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  loader: false,
  listLoader: false,
  error: "",
  dmReportList: [],
  adminReportList: [],
  territoryList: [],
  restaurantList: [],
  adminUserReportList : [],
  adminUsers : [],
  adminRestaurantList : []
};

const reportSlice = createSlice({
  name: "reportSlice",
  initialState,
  reducers: {
    reqToUpdateReportList: (state, action) => {
      state.dmReportList = action.payload;
      state.territoryList = action.payload;
      state.adminReportList = action.payload;
    },
    reqToResetReportList: (state, action) => {
      state.totalReportCounts = 0;
      state.dmReportList = [];
      state.adminReportList = [];
    },
    reqToUpdateAdminReportList: (state,action) => {
      state.adminUserReportList = action.payload || [];
    }
  },
  extraReducers: (builder) => {
    // GET DM REPORT LIST
    builder
      .addCase(reqToGetDMReportList.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToGetDMReportList.fulfilled, (state, action) => {
        state.loader = false;
        state.dmReportList =
          [...state.dmReportList, ...action?.payload?.data?.list] || [];
        state.totalReportCounts = action?.payload?.data?.count || 0;
      })
      .addCase(reqToGetDMReportList.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });

    // GET ADMIN REPORT LIST
    builder
      .addCase(reqToGetAdminReportList.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToGetAdminReportList.fulfilled, (state, action) => {
        state.loader = false;
        state.adminReportList =
          [...state.adminReportList, ...action?.payload?.data?.list] || [];
        state.totalReportCounts = action?.payload?.data?.count || 0;
      })
      .addCase(reqToGetAdminReportList.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });

    // GET TERRITORY LIST
    builder
      .addCase(reqToGetTerritoryList.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToGetTerritoryList.fulfilled, (state, action) => {
        state.loader = false;
        state.territoryList = action?.payload?.data;
      })
      .addCase(reqToGetTerritoryList.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });

    // GET RESTAURANT LIST

    builder
      .addCase(reqToGetDMRestaurantList.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToGetDMRestaurantList.fulfilled, (state, action) => {
        state.loader = false;
        state.restaurantList = action?.payload?.data;
      })
      .addCase(reqToGetDMRestaurantList.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });

    // GET RESTAURANT LIST

    builder
      .addCase(reqToGetAdminRestaurantList.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToGetAdminRestaurantList.fulfilled, (state, action) => {
        state.loader = false;
        state.restaurantList = action?.payload?.data;
      })
      .addCase(reqToGetAdminRestaurantList.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });

    // GET ALL REQUESTED DATA FOR DOWNLOAD PDF AND EXCEL
    builder
      .addCase(reqToGetDMAllReportList.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToGetDMAllReportList.fulfilled, (state, action) => {
        state.loader = false;
      })
      .addCase(reqToGetDMAllReportList.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });

    builder
      .addCase(reqToGetAdminAllReportList.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToGetAdminAllReportList.fulfilled, (state, action) => {
        state.loader = false;
      })
      .addCase(reqToGetAdminAllReportList.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });

      builder
      .addCase(reqToGetAdminUserReportList.pending, (state) => {
        state.listLoader = true;
      })
      .addCase(reqToGetAdminUserReportList.fulfilled, (state, action) => {
        state.listLoader = false;
        state.adminUserReportList = action?.payload?.data?.data;
      })
      .addCase(reqToGetAdminUserReportList.rejected, (state, action) => {
        state.listLoader = false;
        state.error = action.payload;
      });

      builder
      .addCase(reqToGetAdminUsersList.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToGetAdminUsersList.fulfilled, (state, action) => {
        state.loader = false;
        state.adminUsers = action?.payload?.data;
      })
      .addCase(reqToGetAdminUsersList.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });

      builder
      .addCase(reqToGetAdminReportRestaurants.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToGetAdminReportRestaurants.fulfilled, (state, action) => {
        state.loader = false;
        state.adminRestaurantList = action?.payload?.data;
      })
      .addCase(reqToGetAdminReportRestaurants.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });
  },
});

export const { reqToUpdateReportList, reqToUpdateAdminReportList ,reqToResetReportList } =
  reportSlice.actions;
export default reportSlice.reducer;
